/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`La différence entre le paradis et l'enfer fiscal est flagrant, malgré la péréquation financière. C'est ce que montrent les données 2017 que l'Administration fiscale fédérale vient de publier sur l'internet. Cela vaut la peine d'y jeter un regard attentif car votre imposition, qui dépend de vos revenus et de la composition de votre foyer, varie d’un canton à l’autre. Notre carte interactive vous permet ainsi de voir en quelques secondes dans quelle commune votre ménage s'en sortirait le mieux. Et la façon dont votre commune de domiciliation se situe par rapport à ses voisines.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  